/* eslint-disable new-cap */
// import './utils/load_wxjssdk'
import Vue from 'vue'
import VueResource from 'vue-resource'
import App from './App.vue'
import { router } from './router'
import { store } from './store'
import 'intersection-observer'
import './registerServiceWorker'
import './styles/iconfont/iconfont.css'
import './common/widget/MapleIcon/icon.scss'
import { detectMiniProgram } from './defines/environment/getters/detect_mp'
import { wxjssdkInit } from './utils/wxjssdk/init'
import { eventbus } from '@/utils/eventbus'
import { EventNames } from '@/defines/events'
import { cart } from '@/utils/cart/index'
import { userInfo } from '@/utils/user'
import { getDeviceToken } from '@/defines/user/getters/get_device_token'

import { globalRegister } from '@/common/global_register'

import { initConfig, updateTracer } from './init-config'

import './charts'

import SkeletonInit from '@mc/skeleton-project-main-init'

Vue.use(VueResource)

// 不需要调用购物车信息同步的场景
const passCart = () => {
  const { hash } = window.location
  if (
    hash.indexOf('bill') > -1 ||
    hash.indexOf('deliver') > -1 ||
    hash.indexOf('app_download') > -1
    // hash.indexOf('coupon_center')
  )
    return true
  return false
}

const main = async () => {
  await detectMiniProgram()
  wxjssdkInit()
  new SkeletonInit(initConfig).init(Vue)
  getDeviceToken()
  updateTracer()

  globalRegister(Vue)

  Vue.config.productionTip = false

  new Vue({
    router,
    store,
    data() {
      return {
        isLogin: false
      }
    },
    async created() {
      userInfo.getcompany()
      eventbus.addEventListener(EventNames.loginChange, isLogin => {
        this.isLogin !== isLogin && (this.isLogin = isLogin)
      })

      // 因为H5不会走bridge的onLogin方法，所以需要手动调用接口判断是否登录
      // 由于安卓小程序weiview同步更新问题，暂时setTimeout
      if (!passCart()) {
        setTimeout(() => {
          cart
            .sync()
            .then(() => {
              eventbus.dispatch(EventNames.loginChange, true)
            })
            .catch(() => {})
        }, 0)
      }

      if (document.getElementsByTagName('html')[0].style.fontSize === '0px') {
        var SCREEN_WIDTH =
          document.documentElement.clientWidth ||
          document.body.clientWidth ||
          375
        var REM = ((SCREEN_WIDTH * 2) / 15).toFixed(2)
        document.documentElement.style.fontSize = REM + 'px'
      }
    },
    onLogin() {
      this.isLogin = true
    },
    onLogout() {
      this.isLogin = false
    },
    render: h => h(App)
  }).$mount('#app')
}

main()
